import { deriveWorkspaceAccessRequirement, workspaceRoutes } from '#services';
export const needsWorkspaceLockPredicate = ({ workspaceId, workspaceLoginStatus, }) => {
    const isSuccess = deriveWorkspaceAccessRequirement(workspaceLoginStatus) !== null;
    if (isSuccess) {
        return { isSuccess };
    }
    return {
        isSuccess,
        navigateTo: workspaceRoutes.workspace(workspaceId),
    };
};
